import React, { useState, useEffect } from 'react';
import { Accordion, Card, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Loader from '../../Components/Utility/Loader/Loader';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';

const tempObj = {
  name: '',
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
};

function CustomAttrSave(isLoading) {
  return isLoading ? <Spinner animation="border" /> : <i className="icon-Tick-1 f-24" />;
}

function CompositionProcessMaster() {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);

  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const { BOMTypeList, compositionMasterData, compositionsList } = SystemMastersDetails;
  const { userInfo } = UserDetails;

  const { t } = useTranslation('systemMaster');
  const loggedInUserId = userInfo.userId;

  const [isLoadingBSTM, setIsLoadingBSTM] = useState(false);
  const [showBomType, setShowBomType] = useState(false);
  const [isBomTypeUnique, setIsBomTypeUnique] = useState(true);
  const [buttonDownBomType, setButtonDownBomType] = useState(true);
  const [addingBTD, setAddingBTD] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isBOMST, setIsBOMST] = useState(false);
  const [bomSubTypeData, setBomSubTypeData] = useState([]);
  const [isUniqBTDId, setIsUniqBTDId] = useState([]);
  const [charLimitExceededIds, setCharLimitExceededIds] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const [bomSubTypeSelectData, setbomSubTypeSelectData] = useState(null);
  const [compositionMasterSelectData, setCompositionMasterSelectData] = useState(null);
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});

  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);

  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'compositionProcess', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(userRights, 'masters', 'compositionProcess', 'delete');

  useEffect(() => {
    setBomSubTypeData(compositionMasterData);
    if (addingBTD) {
      setBomSubTypeData([
        ...compositionMasterData,
        {
          name: null,
          isEmpty: false,
          isNew: true,
          isActive: true,
          _id: '',
        },
      ]);
    }
  }, [compositionMasterData, addingBTD]);

  const callApi = async () => {
    const willClose = buttonDownBomType;
    setButtonDownBomType(!buttonDownBomType);
    setIsLoadingBSTM(true);

    if (willClose) {
      setShowBomType(true);
      const bomTypeparams = {
        isAllRecord: true,
      };
      if (!bomSubTypeData?.length) {
        await dispatch(action.getBOMTypeDetails(bomTypeparams));
      }
    } else {
      setShowBomType(false);
      setbomSubTypeSelectData(null);
      setCompositionMasterSelectData(null);
      setBomSubTypeData([]);
      setIsBomTypeUnique(true);
      setIsUniqBTDId([]);
      setCharLimitExceededIds([]);
      setAddingBTD(false);
      setIsBOMST(false);
      setDeleteId('');
      setActiveInactiveID('');
    }

    setIsLoadingBSTM(false);
  };

  useEffect(() => {
    bomSubTypeSelectData && Object.keys(bomSubTypeSelectData).length && compositionCalled();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bomSubTypeSelectData]);
  const compositionCalled = async () => {
    const cParams = {
      loggedInUserId,
      bomTypeId: bomSubTypeSelectData._id,
    };
    await dispatch(action.getCompositionsDetails(cParams));
  };
  const handleChanged = (event, i) => {
    const trimmedValue = event.target.value.replace(/^\s+/, '');
    const bomST = [...bomSubTypeData];
    bomST[i] = {
      ...bomST[i],
      name: trimmedValue,
      isEmpty: trimmedValue === '',
    };
    setIsBomTypeUnique(true);
    setIsUniqBTDId([]);

    const charLimitExceeded = [];
    bomST.forEach((item, index) => {
      const itemNameLength = (item?.name || '').trim().length;
      if (itemNameLength > 30) {
        charLimitExceeded.push(index);
      }
    });
    setCharLimitExceededIds(charLimitExceeded);

    const BtDarray = [];
    const BTDarrayIndex = [];
    bomST?.forEach((ele, ind) => {
      bomST?.forEach((objs, index) => {
        if (ele.name === objs.name && ind !== index) {
          BtDarray.push(ele);
          BTDarrayIndex.push(index);
        }
      });
    });
    if (!isEmpty(BtDarray)) {
      const arrs = [...BTDarrayIndex];
      const removeArss = Math.min(...arrs);
      const newArr = BTDarrayIndex.filter((ele) => ele !== removeArss);
      setIsUniqBTDId([...newArr]);
    }
    setIsBomTypeUnique(isEmpty(BtDarray));
    setBomSubTypeData(bomST);
  };

  const handleDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      bomSubTypeData.splice(id, 1);
      setIsBomTypeUnique(true);
      setIsUniqBTDId([]);
      setCharLimitExceededIds([]);
      setBomSubTypeData([...bomSubTypeData]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const bomSubTypeCalled = async () => {
    const bomsubTypeParams = {
      bomTypeId: bomSubTypeSelectData._id,
      compositionMasterId: compositionMasterSelectData?._id,
      loggedInUserId,
    };
    await dispatch(action.getCompositionProcessDetails(bomsubTypeParams));
  };

  const saveBOMST = async () => {
    setIsBOMST(true);
    if (!isEmpty(bomSubTypeData)) {
      const emptyField = bomSubTypeData.filter((bomsitem) => bomsitem.name === null || bomsitem.name === '');

      if (isEmpty(emptyField)) {
        const spacesOnlyFields = bomSubTypeData.filter((bomsitem) => !isEmpty(bomsitem?.name) && isEmpty(bomsitem?.name?.trim()));
        if (!isEmpty(spacesOnlyFields)) {
          setIsBOMST(false);
          return;
        }

        const charLimitExceeded = bomSubTypeData.filter((bomsitem) => (bomsitem?.name || '').trim().length > 30);
        if (!isEmpty(charLimitExceeded)) {
          setIsBOMST(false);
          return;
        }

        const data = bomSubTypeData.map((bomstobj) => {
          return { ...bomstobj, name: bomstobj?.name?.trim() };
        });
        const bomstparams = {
          loggedInUserId,
          bomTypeId: bomSubTypeSelectData._id,
          compositionMasterId: compositionMasterSelectData._id,
          names: JSON.stringify(data),
        };
        setAddingBTD(false);
        await dispatch(action.saveCompositionProcessToSystemMaster(bomstparams, t));
        await bomSubTypeCalled();
      } else {
        const newState = bomSubTypeData.map((bomsobj) => (bomsobj?.isEmpty === false && bomsobj.name === null ? { ...bomsobj, isEmpty: true } : bomsobj));
        setBomSubTypeData(newState);
      }
    }
    setIsBOMST(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const bomTypeDataParams = {
      loggedInUserId,
      compositionProcessID: deleteId,
      bomTypeId: bomSubTypeSelectData._id,
      compositionMasterId: compositionMasterSelectData._id,
    };
    await dispatch(action.deleteCompositionProcessFromSystemMasters(bomTypeDataParams, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setBomSubTypeData([...compositionMasterData]);
    await bomSubTypeCalled();
  };

  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let btd = {};
    bomSubTypeData?.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
        };
        btd = data;
      }
    });
    await dispatch(action.setCompositionProcessActiveInactive(btd, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
    setBomSubTypeData([...bomSubTypeData]);
  };

  useEffect(() => {
    if (bomSubTypeSelectData && compositionMasterSelectData && Object.keys(bomSubTypeSelectData).length && Object.keys(compositionMasterSelectData).length) {
      bomSubTypeCalled();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bomSubTypeSelectData, compositionMasterSelectData]);

  useEffect(() => {
    const array = [];
    bomSubTypeData?.forEach((ele, index) => {
      bomSubTypeData?.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsBomTypeUnique(isEmpty(array));
      setIsUniqBTDId([]);
    }
  }, [bomSubTypeData]);

  const addBOMST = async () => {
    const toggledValue = !buttonDownBomType;

    setAddingBTD(true);
    setButtonDownBomType(toggledValue);
    setIsLoadingBSTM(true);

    if (!toggledValue) {
      setShowBomType(true);

      const bomTypeparams = { isAllRecord: true };

      if (isEmpty(bomSubTypeData)) {
        await dispatch(action.getBOMTypeDetails(bomTypeparams));
      }

      setIsLoadingBSTM(false);
    } else {
      const hasEmpty = bomSubTypeData?.some((item) => !item.name || item.name.trim() === '');

      if (!hasEmpty) {
        setBomSubTypeData([...bomSubTypeData, tempObj]);
      }

      setIsLoadingBSTM(false);
    }
  };

  const handleDropdownChangeBomType = (value) => {
    setbomSubTypeSelectData(value);
    setCompositionMasterSelectData(null);
  };

  const handleDropdownChangeCompositionMaster = (value) => {
    setCompositionMasterSelectData(value);
  };

  return (
    <>
      <Accordion className="mb-4 master-accordian  custom-attribute-master">
        <Card className="card">
          <Card.Header>
            <div className="title-container">
              <p>{t('COMPOSITION_PROCESS_MASTER.TITLE')}</p>
            </div>
            <div className="action-title-btns">
              <CustomTooltip tooltipText={buttonDownBomType ? t('CUSTOM_ATTRIBUTES.OPEN') : t('CUSTOM_ATTRIBUTES.CLOSE')}>
                <button type="button" onClick={callApi} className="btn d-inline-flex p-0">
                  <i className={`icon-new-down-arrow-icon f-24${!buttonDownBomType ? ' icon-inverse' : ''}`} />
                </button>
              </CustomTooltip>
            </div>
          </Card.Header>
          {showBomType && (
            <Card.Body>
              {isLoadingBSTM ? (
                <Loader />
              ) : (
                <>
                  <div className="select-container">
                    <div className="common-react-select mb-0">
                      <Select
                        options={[...BOMTypeList]}
                        placeholder={t('BOM_TYPE_MASTER.SELECT_BOM_TYPE')}
                        getOptionLabel={(option) => `${option.name}`}
                        getOptionValue={(option) => `${option._id}`}
                        name="bomsubtype"
                        value={bomSubTypeSelectData}
                        maxMenuHeight={130}
                        className="common-select"
                        classNamePrefix="common-select"
                        onChange={handleDropdownChangeBomType}
                      />
                    </div>
                  </div>
                  {bomSubTypeSelectData && Object.keys(bomSubTypeSelectData).length !== 0 && (
                    <div className="select-container">
                      <div className="common-react-select mb-0">
                        <Select
                          options={[...compositionsList]}
                          placeholder={t('COMPOSITION_PROCESS_MASTER.SELECT_COMPOSITION_MASTER')}
                          getOptionLabel={(option) => `${option.name}`}
                          getOptionValue={(option) => `${option._id}`}
                          name="compositionmaster"
                          value={compositionMasterSelectData}
                          maxMenuHeight={130}
                          className="common-select"
                          classNamePrefix="common-select"
                          onChange={handleDropdownChangeCompositionMaster}
                        />
                      </div>
                    </div>
                  )}
                  <div className="common-scrollbar flex-fill">
                    <ul>
                      {bomSubTypeSelectData &&
                        compositionMasterSelectData &&
                        Object.keys(bomSubTypeSelectData).length !== 0 &&
                        Object.keys(compositionMasterSelectData).length !== 0 &&
                        !isEmpty(bomSubTypeData) &&
                        bomSubTypeData.map((boms, bomsIndex) => {
                          return (
                            <li key={boms?._id}>
                              <div className="input-container">
                                <input
                                  name="bomTypeData"
                                  value={boms?.name ? boms?.name : ''}
                                  type="text"
                                  autoFocus={!boms?._id}
                                  placeholder={t('COMPOSITION_PROCESS_MASTER.ENTER_NAME')}
                                  maxLength={30}
                                  onChange={(e) => handleChanged(e, bomsIndex)}
                                />
                                {!isEmpty(isUniqBTDId) && isUniqBTDId.includes(bomsIndex) && (
                                  <label className="text-danger p-1">{t('COMPOSITION_PROCESS_MASTER.ENTRY_ALREADY_EXIST')}</label>
                                )}
                                {charLimitExceededIds.includes(bomsIndex) && (
                                  <label className="text-danger p-1">
                                    {t('COMPOSITION_PROCESS_MASTER.MAX_30_CHAR_ALLOWED') || t('MAX_30_CHAR') || 'Maximum 30 characters allowed'}
                                  </label>
                                )}
                                {boms?.isEmpty && (boms?.name === null || boms?.name === '') && (
                                  <label className="text-danger p-1">{t('COMPOSITION_PROCESS_MASTER.NAME_IS_REQUIRED')}</label>
                                )}
                                {boms?.isNew && !isEmpty(boms?.name) && isEmpty(boms?.name?.trim()) && (
                                  <label className="text-danger p-1">{t('COMPOSITION_PROCESS_MASTER.NAME_ENTRY_INVALID')}</label>
                                )}
                              </div>
                              <div className="input-action d-flex">
                                {boms?._id !== '' && MasterAddEditAccess && (
                                  <CustomTooltip tooltipText={t('SYSTEM_MASTER_TABLE.ACTIVE/INACTIVE')}>
                                    <button
                                      onClick={() => activeInactiveClicked(boms?._id)}
                                      id={boms?._id}
                                      type="button"
                                      className="btn p-0 custom-action mr-0"
                                      aria-label={boms?.isActive ? 'Active' : 'Inactive'}
                                    >
                                      <span className={boms.isActive ? 'icon-Eye-Open' : 'icon-Eye-Closed'} />
                                    </button>
                                  </CustomTooltip>
                                )}
                                {MasterDeleteAccess && (
                                  <CustomTooltip tooltipText={t('SYSTEM_MASTER_TABLE.DELETE')}>
                                    <button
                                      onClick={() => {
                                        handleDelete(boms?._id ? boms?._id : bomsIndex);
                                      }}
                                      type="button"
                                      className="btn custom-action mr-0"
                                      aria-label="delete"
                                    >
                                      <span className="icon-Delete f-24" />
                                    </button>
                                  </CustomTooltip>
                                )}
                              </div>
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                  <div className="license-btn-container">
                    {MasterAddEditAccess && (
                      <>
                        <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.ADD_TOOLTIP')}>
                          <button
                            type="button"
                            onClick={addBOMST}
                            className="btn btn-outline sm ml-auto mr-0 mt-16 p-0"
                            disabled={!isBomTypeUnique}
                            aria-label="Add"
                          >
                            <span className="icon-Add text-grey" />
                          </button>
                        </CustomTooltip>
                        <div className="section-custom-save">
                          <button
                            aria-label="Save"
                            type="button"
                            className="btn p-0"
                            onClick={saveBOMST}
                            disabled={!isBomTypeUnique || !isEmpty(charLimitExceededIds)}
                          >
                            {CustomAttrSave(isBOMST)}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
            </Card.Body>
          )}
        </Card>
      </Accordion>
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('BOM_TYPE_MASTER.DELETE_FROM_SYSTEM_MASTER')}
          message={t('BOM_TYPE_MASTER.ARE_YOU_SURE_DELETE_ITEM')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('BOM_TYPE_MASTER.ACTIVATE_DEACTIVATE')}
          message={t('BOM_TYPE_MASTER.ARE_YOU_SURE_ACTIVATE_DEACTIVATE')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default CompositionProcessMaster;
